enum FilterItemsGroupOperation {
  LogicalAnd = "And",
  LogicalOr = "Or",
}

enum FilterItemType {
  Leaf = "leaf",
  Branch = "branch",
}

export { FilterItemsGroupOperation, FilterItemType };
